<template>
  <loading-overlay v-if="loading" class="animated fadeIn"></loading-overlay>
  <div class="animated fadeIn" v-else>
    <default-heading class="mt-3">Orders</default-heading>
    <invoice-server-table v-if="invoices" :invoices="invoices"></invoice-server-table>
  </div>
</template>

<script>
  import DefaultHeading from "@/components/shared/DefaultHeading";
  import InvoiceServerTable from "@/components/cashier/invoice/InvoiceServerTable";
  import InvoiceCollection from "../../collections/cashier/InvoiceCollection";
  import LoadingOverlay from "../../components/shared/LoadingOverlay";

  export default {
    name: 'OrderIndex',
    components: {
      LoadingOverlay,
      InvoiceServerTable,
      DefaultHeading,
    },
    data() {
      return {
        loading: true,
        authenticated_customer_id: this.$store.getters.getAuthCustomerID,
        invoices: null
      }
    },
    methods: {
      fetch() {
        let invoices = new InvoiceCollection();
        invoices.getFilter().filterEquals('customer_id', this.authenticated_customer_id);
        invoices.getFilter().cacheStaticFilters();
        this.invoices = invoices;
        /*let collection = new InvoiceCollection();
        collection.getFilter().filterEquals('customer_id', this.authenticated_customer_id);
        let p1 = collection.fetch().then(() => {
          this.invoices = collection;
        });
        return Promise.all([p1]);*/
        return Promise.all([]);
      },
    },
    mounted() {
      this.loading = true;
      this.fetch().then(() => {
        this.loading = false;
      });
    },
  };
</script>
